module.exports = __webpack_public_path__ + "img/eco4.027e75a6.png";